import { useFrame, useThree } from '@react-three/fiber'
import React, { useEffect } from 'react'
import { useClickStore } from '../store/clickStore'
import { useShallow } from 'zustand/react/shallow'
import TWEEN from 'tween'
import * as THREE from 'three'

const DEFAULT_CAMERA_SETTINGS = {
    camPos: { x: 794138, y: 2500 , z: 7978950  },
    lookAt: { x: 794138, y: 1080, z: 7978850 },
};

const reusableVector = new THREE.Vector3();

export default function CameraControl({ controls }) {
    const { camera } = useThree();

    const { zoomPosition, zoomToExtent, setZoomToExtent } = useClickStore(
        useShallow((state) => ({
            zoomPosition: state.zoomPosition,
            zoomToExtent: state.zoomToExtent,
            setZoomToExtent: state.setZoomToExtent,
        }))
    );

    useEffect(() => {
        if (zoomToExtent) {
            zoomToDefault(controls, camera);
            setZoomToExtent(false);
        }
    }, [zoomToExtent]);

    useEffect(() => {
        if (zoomPosition) {
            const campos = findPointC(camera.position, zoomPosition);
            console.log('zoom clicked', zoomPosition, camera.position, campos);

            createTween(controls.current.target, zoomPosition, 1100);
            createTween(camera.position, campos, 1000);

            console.log(
                'zoom clicked',
                zoomPosition,
                camera.position,
                campos
            );
        }
    }, [zoomPosition]);

    // Add TWEEN.update() to the render loop
    useFrame(() => {
        TWEEN.update();
    });

    return null;
}

function findPointC(pointA, pointB) {
    // Get vector from A to B
    reusableVector.subVectors(pointB, pointA);

    // Store the distance before we overwrite reusableVector
    const distanceAB = reusableVector.length();

    // Get the normalized direction
    const directionAB = reusableVector.clone().normalize();

    // Compute point C = A + direction * (distance - 10)
    return reusableVector
        .copy(pointA)
        .add(directionAB.multiplyScalar(distanceAB - 10));
}


function zoomToDefault(controls, camera) {
    const { camPos, lookAt } = DEFAULT_CAMERA_SETTINGS;

    createTween(controls.current.target, lookAt, 2100);
    createTween(camera.position, camPos, 2000);
}

function createTween(target, to, duration) {
    new TWEEN.Tween(target)
        .to(
            {
                x: to.x,
                y: to.y,
                z: to.z,
            },
            duration
        )
        .easing(TWEEN.Easing.Cubic.Out)
        .start();
}

